import type { Plugin } from "vue";

export default {
  install(app) {
    app.config.globalProperties.currency = currency;
    app.config.globalProperties.date = date;
    app.config.globalProperties.datetime = datetime;
    app.config.globalProperties.integer = integer;
    app.config.globalProperties.pluralize = pluralize;
  },
} as Plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    currency: typeof currency;
    date: typeof date;
    datetime: typeof datetime;
    integer: typeof integer;
    pluralize: typeof pluralize;
  }
}
